<template>
    <div id="app">
		<notifications group="foo" position="bottom right" />
        <router-view/>
    </div>
</template>
<script>
    import '../static/fxView/js/jquery.min.js'
    import '../static/fxView/js/popper.min.js'
    import '../static/fxView/js/bootstrap.min.js'
    import * as types from './types'
	export default {
		name: 'app',
		created() {},       
    }
</script>
<style>
    @import '../static/fxView/css/bootstrap.min.css';
    @import '../static/fxView/css/style.css';
    @import '../static/fxView/css/responsive.css';
</style>


// WEBPACK FOOTER //
// src/App.vue